import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import { Text } from 'native-base';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useEffect, useMemo, useState } from 'react';

import { CommonStore } from '@/app/core/store/common/common-store';
import { TwTabs } from '@tw/tw-components-rn';
import { View } from 'react-native';
import { MallContent } from './viewparts/MallContent';

export const GiftGiftMall = (props) => {
  const commonStore = CommonStore.getInstance();
  const [store] = useState(commonStore);

  // useFocusEffect(
  //   useCallback(() => {
  //     store.onLoad(props.route.params);
  //   }, [props.route.params, store])
  // );
  // useMount(() => {
  //   store.onLoad(props.route.params);
  // });
  useEffect(() => {
    store.onLoad(props.route.params);
  }, [props.route.params, store]);

  const productTypeEnum = useStoreState(store, (state) => state.productTypeEnum);
  const productType = useStoreState(store, (state) => state.productType);

  const renderLazyPlaceHolder = () => {
    return (
      <View>
        <Text>加载中...</Text>
      </View>
    );
  };

  const tabItems = useMemo(() => {
    // const tabs = [
    //   {
    //     key: RecommondType,
    //     label: '推荐',
    //     children: () => mallContent
    //   }
    // ];
    return productTypeEnum?.map((item, _index) => {
      return {
        key: item.code,
        label: item.name,
        children: () => <MallContent />
      };
    });
  }, [productTypeEnum]);

  if (!productTypeEnum) {
    return renderLazyPlaceHolder();
  }

  return (
    <BfPageStoreProvider store={store}>
      <TwTabs
        lazy={true}
        items={tabItems}
        tabBarScrollable={false}
        renderLazyPlaceholder={() => renderLazyPlaceHolder()}
        activeKey={productType}
        // tabBarWidth={300}
        onTabChange={(index) => {
          store.onFilterChange(index);
        }}
        animationEnabled={false}
        swipeEnabled={false}
      />
    </BfPageStoreProvider>
  );
};
